import { getToken } from './auth'
import api, { baseUrl } from './axios'

const validationThreeActionType = keys =>
  !Array.isArray(keys) || keys.length !== 4

const timeout = 30000

export const getMethod = (method = 'get') => {
  switch (method) {
    case 'post':
      return { httpMethod: api.post, hasData: true }
    case 'put':
      return { httpMethod: api.put, hasData: true }
    case 'patch':
      return { httpMethod: api.patch, hasData: true }
    case 'delete':
      return { httpMethod: api.delete, hasData: false }
    default:
      return { httpMethod: api.get, hasData: false }
  }
}

export const callApi = async (
  store,
  endpoint,
  retries = 0,
  method = 'get',
  data = null
) => {
  const { httpMethod, hasData } = getMethod(method)
  const accessToken = getToken()

  const headers = {}
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`
  }

  const config = {
    timeout: timeout,
    headers
  }

  if (!hasData && data) {
    config['params'] = data
  }

  try {
    const url = baseUrl

    const response = await httpMethod(
      url + endpoint,
      hasData ? data : config,
      hasData ? config : undefined
    )
    return response.data
  } catch (err) {
    if (retries > 0) {
      return callApi(store, endpoint, retries - 1, method, data)
    }
    if (err.message === 'Network Error') {
      localStorage.setItem('NETWORK_ERROR', true)
    }
    return Promise.reject(JSON.stringify(err))
  }
}

export const CALL_API = Symbol('Call API')

export default store => next => action => {
  const callAPI = action[CALL_API]

  if (typeof callAPI === 'undefined') {
    return next(action)
  }

  let { endpoint, retries } = callAPI
  const { method, data } = callAPI
  const { type, params = {} } = callAPI

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState())
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.')
  }
  const keys = Object.keys(type)
  if (validationThreeActionType(keys)) {
    throw new Error('Expected an array of three action type.')
  }
  if (!keys.every(_type => typeof _type === 'string')) {
    throw new Error('Expected action type to be strings.')
  }

  function actionWith(actionData) {
    const finalAction = Object.assign({}, action, actionData)
    delete finalAction[CALL_API]
    return finalAction
  }

  if (!retries) {
    retries = 0
  }

  next(actionWith({ type: type.BEGIN, ...params }))
  return callApi(store, endpoint, retries, method, data).then(
    response =>
      next(
        actionWith({
          response,
          type: type.SUCCESS,
          ...params
        })
      ),
    error => {
      next(
        actionWith({
          type: type.ERROR,
          error: JSON.parse(error) || 'Something bad happened',
          ...params
        })
      )
    }
  )
}
